export enum QuickCheckoutActionType {
  PAYMENT_SUCCESS = "QUICK_CHECKOUT.ACTIONS.PAYMENT.SUCCESS",
  BASKET_SUCCESS = "QUICK_CHECKOUT.ACTIONS.BASKET.SUCCESS",
  SUMMARY_SUCCESS = "QUICK_CHECKOUT.ACTIONS.SUMMARY_SUCCESS",
  ITEMS_ADDED = "QUICK_CHECKOUT.ACTIONS.ITEMS_ADDED", // Analytics-only signal for quick purchase
  SUMMARY_PENDING = "QUICK_CHECKOUT.ACTIONS.SUMMARY_PENDING",
  SUMMARY_ERROR = "QUICK_CHECKOUT.ACTIONS.SUMMARY_ERROR",
}
